module.exports = __webpack_public_path__ + "img/JB_bie.6a8ce4b4.png";